module.exports = __webpack_public_path__ + "fonts/Raleway-BoldItalic.34872de2.woff2";